import React from 'react';

/*
 * LoyalPass brand: a black rounded square with a white « L », and the name in
 * spaced capitals. Sober on purpose (same family as Planity, Qonto…): the
 * merchants' cards bring the colour, the brand stays black and white.
 * Same drawing as public/favicon.svg and the app icons — keep them in sync.
 */

export const BRAND_INK = '#0B0D12';
const L_PATH = 'M24 16h6.5v25.5H43V48H24Z';

export const BrandMark = ({ size = 32, tone = 'dark', className = '', title }) => {
  const light = tone === 'light';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <rect width="64" height="64" rx="14" fill={light ? '#FFFFFF' : BRAND_INK} />
      <path d={L_PATH} fill={light ? BRAND_INK : '#FFFFFF'} />
    </svg>
  );
};

/* Mark + wordmark. `tone="light"` for dark backgrounds.
   `collapse`: on very narrow phones (< 400px) keep only the mark, so a header
   with two buttons never overflows. */
export const BrandLogo = ({ size = 'md', tone = 'dark', collapse = false, className = '' }) => {
  const s = { sm: [24, 'text-[15px]'], md: [30, 'text-[17px]'], lg: [36, 'text-[20px]'] }[size] || [30, 'text-[17px]'];
  const light = tone === 'light';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="LoyalPass">
      <BrandMark size={s[0]} tone={tone} />
      <span
        aria-hidden="true"
        className={`${s[1]} font-semibold leading-none tracking-[0.16em] ${light ? 'text-white' : 'text-[#0B0D12]'} ${collapse ? 'max-[400px]:hidden' : ''}`}
      >
        LOYALPASS
      </span>
    </span>
  );
};

export default BrandLogo;
